import { apiConfig } from '../api-config';

export interface ActCreateParams {
  territoryId: string;
  tokenKey: string;
  dtAutovistory: string;
  score: string;
  period: string;
}

export const actCreate = async (params: ActCreateParams) => apiConfig.post('api/ActDocument/create', params).then((resp) => resp.data);
